<template>
  <TgSlidePanel :open="showFormPanel" :on-close="closeFormPanel" side="left" width="max-w-5xl" :overlay="true" z="z-40">
    <template #title>
      FR-{{ item.id }}
    </template>
    <template #subtitle>
      Flight report form
    </template>
    <template #content>
      <form-panel
        ref="FormPanel" :slug="slug" :tab="tab" :selected="item" @formerror="formHasError"
        @formsuccess="receiveFormData"
      />
    </template>
    <template #footer>
      <TgSubmit :disabled="submitting" @click="submitForm">
        Update
      </TgSubmit>
    </template>
  </TgSlidePanel>

  <div v-if="item" class="el_1_f08d9a633a0e7d7808a0f51038aa8648 bg-gray-100 rounded-md">
    <div
      class="el_2_f08d9a633a0e7d7808a0f51038aa8648 p-3 uppercase rounded-t-md"
      :class="stage_colors[item.stage_color]"
    >
      <div class="el_3_f08d9a633a0e7d7808a0f51038aa8648 flex items-center text-white">
        <div class="el_4_f08d9a633a0e7d7808a0f51038aa8648 flex-1 text-lg">
          Flight report #{{ item.id }} -
          <span class="el_5_f08d9a633a0e7d7808a0f51038aa8648 text-base">({{ item.hoursremaining }} Remain)</span>
        </div>
        <div class="el_6_f08d9a633a0e7d7808a0f51038aa8648 flex-shrink-0 text-right">
          <TgBadge v-if="tab.access == 'Full'" color="dark" class="cursor-pointer" @click="openForm()">
            Edit
          </TgBadge>
        </div>
      </div>
    </div>
    <div class="el_7_f08d9a633a0e7d7808a0f51038aa8648 flex flex-col px-4 py-4 space-y-2">
      <div class="el_8_f08d9a633a0e7d7808a0f51038aa8648 flex-1 space-y-2">
        <div class="el_9_f08d9a633a0e7d7808a0f51038aa8648 flex items-center">
          <!-- <div class="el_10_f08d9a633a0e7d7808a0f51038aa8648 w-1/4">
            <div class="el_11_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              Section
            </div>
            <div class="el_12_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 whitespace-normal">
              {{ item.section }}
            </div>
          </div> -->
          <div class="el_13_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_14_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              category
            </div>
            <div class="el_15_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.category }}
            </div>
          </div>
          <div class="el_16_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_17_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              subcategory
            </div>
            <div class="el_18_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.subcategory }}
            </div>
          </div>
          <div class="el_19_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_20_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              cabin class
            </div>
            <div class="el_21_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.cabinclass }}
            </div>
          </div>
        </div>
        <div class="el_22_f08d9a633a0e7d7808a0f51038aa8648 flex items-center">
          <div class="el_23_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_24_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              Derived Supplier
            </div>
            <div class="el_25_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.supplier }}
            </div>
          </div>
          <div class="el_26_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_27_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              Derived Port
            </div>
            <div class="el_28_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.caterer }}
            </div>
          </div>
          <div class="el_29_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_30_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              Service Port
            </div>
            <div class="el_31_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.serviceport }}
            </div>
          </div>
        </div>
        <div class="el_35_f08d9a633a0e7d7808a0f51038aa8648 flex items-center">
          <div class="el_32_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_33_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              Hours Remaining
            </div>
            <div class="el_34_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.hoursremaining }}
            </div>
          </div>
          <div class="el_36_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_37_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              OTP Minutes
            </div>
            <div class="el_38_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.minutes || "N/A" }}
            </div>
          </div>

          <!-- <div class="el_39_f08d9a633a0e7d7808a0f51038aa8648 w-2/4">
            <div class="el_40_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              MSC Flight
            </div>
            <div class="el_41_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.mscflag || "N/A" }}
            </div>
          </div> -->
        </div>
      </div>
      <div class="el_42_f08d9a633a0e7d7808a0f51038aa8648 flex-col space-y-3">
        <div class="el_43_f08d9a633a0e7d7808a0f51038aa8648 flex-1">
          <div class="el_44_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
            <template v-if="$auth.client.value.key == 'nz'">
              Operational Comment
            </template>
            <template v-else>
              Crew Comment
            </template>
          </div>
          <div class="el_45_f08d9a633a0e7d7808a0f51038aa8648 text-base text-gray-600 whitespace-pre-line ">
            {{ item.comments }}
          </div>
        </div>
        <div class="el_46_f08d9a633a0e7d7808a0f51038aa8648 flex-1">
          <div class="el_47_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
            Caterer Comment
          </div>
          <div class="el_48_f08d9a633a0e7d7808a0f51038aa8648 text-base text-gray-600 whitespace-normal">
            <TgBadge :color="item.supplier_css">
              {{ item.status }}
            </TgBadge>
            {{ item.catererresponse }}
          </div>
        </div>
        <div class="el_49_f08d9a633a0e7d7808a0f51038aa8648 flex-1">
          <div class="el_50_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
            Airline Reply
          </div>
          <div class="el_51_f08d9a633a0e7d7808a0f51038aa8648 text-base text-gray-600 whitespace-normal">
            <TgBadge :color="item.airline_css">
              {{ item.status_airline }}
            </TgBadge>
            {{ item.airlineresponse }}
          </div>
        </div>

        <template v-if="$auth.client.value.key == 'nz'">
          <div v-if="attachments.length > 0" class="text-gray-400 uppercase pt-2">
            Attachments
          </div>
          <div class="flex space-x-2">
            <div v-for="(attachment, file_idx) in attachments" :key="file_idx" class="flex-shrink-0 px-3">
              <div class="text-center group flex flex-col hover:cursor-pointer">
                <a class="h-16" :href="attachment.secure_url" target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-16 h-16 mx-auto"
                  >
                    <path
                      stroke-linecap="round" stroke-linejoin="round"
                      d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                    />
                  </svg>
                </a>
                <a class="text-center text-sm cursor-pointer" :href="attachment.secure_url" target="_blank">{{
                  getFilenameFromLink(attachment.secure_url) }}</a>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <div v-if="imageUrlArray.length > 0" class="flex-1">
            <!-- Section Title -->
            <h3 class="mb-2 text-sm font-semibold text-gray-500 uppercase tracking-wide">
              Attachments
            </h3>

            <div class="flex flex-wrap gap-3">
              <div v-for="(attachment, file_idx) in imageUrlArray" :key="file_idx" class="flex-shrink-0">
                <div class="text-center group flex flex-col hover:cursor-pointer">
                  <a class="h-12" @click="get_secure_download_url(attachment.secure_url)">
                    <svg
                      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                      stroke="currentColor" class="w-12 h-12 mx-auto"
                    >
                      <path
                        stroke-linecap="round" stroke-linejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                      />
                    </svg>
                  </a>
                  <a
                    class="text-center text-xs cursor-pointer max-w-20 truncate text-sky-500 hover:text-sky-800 underline"
                    @click="get_secure_download_url(attachment.secure_url)"
                  >
                    Image {{ file_idx + 1 }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="el_54_f08d9a633a0e7d7808a0f51038aa8648 flex-1 mt-3 text-center">
          <div class="el_55_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
            Overall Status
          </div>
          <div class="el_56_f08d9a633a0e7d7808a0f51038aa8648 text-2xl text-gray-600 whitespace-normal">
            <TgBadge :color="item.stage_css">
              {{ item.stage }}
            </TgBadge>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TgSlidePanel from "@/components/Common/TgSlidePanel.vue";
import { API } from "@/api";
import { UTILS } from "@/utils";
import { STATUS_COLORS } from "@/default";
import TgBadge from "@/components/Common/TgBadge";
import TgSubmit from "@/components/Common/TgSubmit";
import dayjs from "dayjs";

import _has from "lodash/has";
import _get from "lodash/get";
import _each from "lodash/each";
import FormPanel from "@/components/Grids/FormPanel.vue";

export default {
  components: {
    TgSlidePanel,
    TgSubmit,
    FormPanel,
    TgBadge,
  },
  props: {
    item: Object,
    config: Object,
    tab: Object,
    refreshlist: Function,
  },
  emits: ["on:update"],
  data() {
    return {
      emitter: API.get_emitter(),
      // item: null,
      attachments: JSON.parse(_get(this.item, "attachments", "[]")),
      colors: STATUS_COLORS,
      categories: null,
      guid: UTILS.guid(),
      open: false,
      submitting: false,
      showFormPanel: false,
      slug: null,
      stage_colors: {
        red: "bg-red-400 text-white",
        yellow: "bg-yellow-400 text-white",
        blue: "bg-primary-400 text-white",
        green: "bg-green-400 text-white",
      },
    };
  },
  computed: {
    imageUrlArray() {
      if (!this.item.image_url) return [];

      try {
        const parsed = JSON.parse(this.item.image_url);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.warn('Failed to parse image_url JSON:', error);
        return [];
      }
    },
  },
  methods: {
    getFilenameFromLink(link) {
      const url = new URL(link);
      const pathParts = url.pathname.split("/");
      return pathParts[pathParts.length - 1];
    },
    async get_secure_download_url(link) {
      this.sending = true;

      this.status = "Getting secure download location...";

      let resp = await API.get_secure_download_url(link)

      if (resp) {
        this.sending = false;
        let url = resp.data.data;
        let win = window.open(url, "_blank");
        win.focus();
      }
    },
    async get_secure_upload_url(file) {


      let today = dayjs().format("YYYY/MM/DD");

      const params = {
        action: "put",
        folder: `TTL=99-Years/worker=service-reports/${today}/${this.item.id}`,
        filekey: `TTL=99-Years/worker=service-reports/${today}/${this.item.id}/${file.name}`,
        pub: 0,
        filetype: file.type,
      };

      try {
        const resp = await API.get_secure_upload_url(this.slug, file.name, params);
        const { filename, key, link, url } = resp.data.data;

        await this.upload(file, url);

        // Use the link provided by API if available, fallback to known path
        return { link: link };
      } catch (err) {
        console.error("Error getting secure upload URL:", err);
        throw err;
      }
    },
    async upload(file, signedUrl) {
      try {
        await fetch(signedUrl, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": file.type,
          },
        });
      } catch (err) {
        console.error("Error uploading file:", err);
        throw err;
      }
    },
    isImage(filename) {
      const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'svg'];
      const ext = filename.split('.').pop().toLowerCase();
      return imageExtensions.includes(ext);
    },

    async onChange(event) {
      const files = event.target.files;
      if (files.length > 0) {
        try {
          const uploadPromises = Array.from(files).map((file) => this.get_secure_upload_url(file));
          const uploadedFiles = await Promise.all(uploadPromises);
          this.afterUpload(uploadedFiles);
        } catch (error) {
          console.error("Upload error:", error);
          // Optionally notify the user here
        }
      }
    },
    async afterUpload(files) {

      let attachments = JSON.parse(JSON.stringify(this.attachments));
      _each(files, (file) => {
        attachments.push({
          secure_url: file.link
        });
      });
      let id = this.item._hashid || this.item.id;
      await API.update("84D444B71CE4441CADED9890820B3805", id, {
        attachments: JSON.stringify(attachments),
      });
      this.$emit("on:refresh");
    },
    async remove_attachement(idx) {

      let result = await this.$swal.fire({
        title: "Please confirm",
        text: `You are about to delete this attachment. Are you sure?`,
        showCancelButton: true,
        confirmButtonText: "Yes",
      });

      if (!result.isConfirmed) return;

      this.attachments.splice(idx, 1);
      let id = this.item._hashid || this.item.id;
      await API.update("84D444B71CE4441CADED9890820B3805", id, {
        attachments: JSON.stringify(this.attachments),
      });
      this.$notify({
        group: "toast",
        type: "success",
        title: "Success",
        text: "Attachment removed.",
      });
    },
    triggerFilePickerAndReset() {
      // Reset the file input and trigger click
      this.$refs.fileRef.value = "";
      this.$refs.fileRef.click();
    },

    openForm() {
      let slug = "6464A3BE24474C98B28DB96AF4D9E9BD"; // HO form

      if (_has(this.config, "supplier")) {
        if (this.item.stage == "Closed IFS") {
          this.$notify({
            group: "toast",
            type: "danger",
            title: "Edit Denied",
            text: "This report has been closed. No changes can be made.",
          });
          return;
        }

        slug = "059C953AD93D456C9E1823FCFDB65995"; // supplier form - VA
        if (this.$auth.client.value.key == "ib") {
          if (this.item._canedit == 0) {
            this.$notify({
              group: "toast",
              type: "danger",
              title: "Edit Denied",
              text: "This report has been closed. No changes can be made.",
            });
            return;
          }

          slug = "CB33B3605C05442087833B872D73186A"; // supplier form - IB
        }
      } else {
        if (this.$auth.client.value.key == "ib") {
          slug = "7C2F568ADF5344B0885FCA0C16FD4221"; // HO form

          if (this.item._canedit_ho == 0) {
            this.$notify({
              group: "toast",
              type: "danger",
              title: "Edit Denied",
              text: "The caterer must reply first before you can edit this.",
            });
            return;
          }
        }
      }
      this.slug = slug;
      this.openFormPanel();
    },
    openFormPanel() {
      this.showFormPanel = true;
    },
    formHasError() {
      this.submitting = false;
    },
    async receiveFormData(data) {
      this.submitting = false;
      if (this.$auth.client.value.key == "va") {
        await API.proc({
          proc: "SLAp_01_RefreshSLARunner_byID",
          params: [data.row.id],
        });
      }
      this.emitter.emit("crew-report-updated");
      this.refreshlist();
      this.closeFormPanel();
    },
    submitForm() {
      this.submitting = true;
      this.$refs.FormPanel.submit();
    },
    closeFormPanel() {
      this.showFormPanel = false;
    },
  },
};
</script>
<style></style>
;
